export const getBenchmarkAchieved = state => {
  const { cached, date } = state.feedback;
  const { achieved } = state.division.benchmark;
  return (
    achieved +
    cached.filter(f => new Date(f.created_at).toDateString() === date).length
  );
};
